import React, { FC } from 'react';
import { Card, CardBody } from 'reactstrap';

interface VisitationProps {
  type: 'premium-methodology' | 'home';
  children: React.ReactNode;
}

const Visitation: FC<VisitationProps> = ({ type, children, ...props }) => {

  const imageMap = {
    'premium-methodology': '/Images/about-premium.jpg',
    'home': '/Images/vistatron-home-new.jpg',

  };
  //assign image based on the type
  const image = imageMap[type] || imageMap['home'];

  return (
    <Card
      {...props}
      className='visitation'
      style={{
        backgroundImage: image ? `url(${image})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '30vh',
        width: '100%',
          border: "1px solid #f5f5f5",
          borderRadius: '0',
      }}
    >
      <CardBody >{children}</CardBody>
    </Card>
  );
};

export default Visitation;
